// extracted by mini-css-extract-plugin
export var active = "_ip-2";
export var recordingDot = "_ip-1";
export var recordingIndicator = "_ip-0";